var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.params.data.to_user_details),function(name){return _c('span',{key:name.client_main_id},[_vm._v("\n     "+_vm._s(name.first_name)+" "+_vm._s(name.last_name)+"\n ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }